///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum IsPopEnum {
    IS_POP = 1,
    NO_POP = 0
}
